import { useEffect } from 'react'
import { useSessione } from '../../servizi/sessione.tsx'
import { Bottone } from '../../componenti/base.tsx'
import { Pie } from '../../componenti/Pezzi.tsx'
import { NastroPalestra } from '../../componenti/Palestra.tsx'
import { FasciaImpersonazione } from '../../componenti/FasciaImpersonazione.tsx'
import { AvvisiSchermo } from '../../componenti/AvvisiSchermo.tsx'
import { Posta } from '../Posta.tsx'

/**
 * La webmail nella finestra a parte (/posta/finestra, servizi/posta-finestra.ts): la pagina Posta intera, con
 * le sue linguette, senza menu laterale e testata. Restano i nastri che devono stare su ogni pagina:
 * registrazione dello schermo (art. 4 l. 300/1970), impersonazione in sola lettura (524) e palestra (490).
 */
export function FinestraPosta() {
  const { avvisoRegistrazione, modalitaRegistrazione, registrazionePerAssistenza } = useSessione()

  // Il titolo distingue la finestra dal gestionale nella barra delle applicazioni.
  useEffect(() => {
    const prima = document.title
    document.title = 'Posta · Gestionale CIDIS'
    return () => { document.title = prima }
  }, [])

  return (
    <div className="impalcatura impalcatura-finestra">
      {avvisoRegistrazione && (
        <div className="nastro-registrazione" role="status">
          <span className="pallino-registrazione" aria-hidden="true" />
          <span>{avvisoRegistrazione}</span>
          {modalitaRegistrazione === 'assistenza' && (
            <span className="spinta">
              <Bottone variante="discreto" dimensione="piccolo"
                       onClick={() => void registrazionePerAssistenza(false)}>
                Interrompi
              </Bottone>
            </span>
          )}
        </div>
      )}
      <FasciaImpersonazione />
      <NastroPalestra />

      <div className="corpo">
        <main className="contenuto">
          <Posta finestra />
        </main>
      </div>

      <AvvisiSchermo />
      <Pie />
    </div>
  )
}
